import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import FlowExplorer from '@/components/feature/FlowExplorer';
import { rightsFlow } from '@/mocks/jiuchou-business';

export default function RightsSystem() {
  return (
    <section className="w-full bg-foreground-950 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            dark
            eyebrow="权益系统"
            title="一套权益，连接消费与产业"
            subtitle="权益不是独立存在，而是绑定真实商品、真实服务和真实消费。"
          />
        </Reveal>

        <Reveal delay={100}>
          <div className="mt-12">
            <FlowExplorer steps={rightsFlow} direction="horizontal" accent="primary" dark />
          </div>
        </Reveal>

        <Reveal delay={150}>
          <p className="mt-8 text-center text-foreground-300 text-sm max-w-3xl mx-auto leading-relaxed">
            重点体现：权益不是独立存在，而是绑定真实商品、真实服务和真实消费。这让投资人更容易理解九畴云铺的「消费引擎」。
          </p>
        </Reveal>
      </div>
    </section>
  );
}